<template>
  <v-container>
    <v-row justify="center">
      <span @click="crear()" class="punto">¿Olvidaste Contraseña?</span>
      <v-dialog v-model="value" persistent max-width="600px">
        <v-card>
          <v-toolbar
            color="headforms"
            height="30"
            elevation="0"
            dense>
            <v-spacer></v-spacer>
            <span class="mdlHeadForms font-weight-bold">Restablecer contraseña</span>
            <v-spacer></v-spacer>
            <v-btn 
              color="btncolor"
              @click="CloseDialog()"
              icon
              small>
              <v-icon>fa fa-times</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-form>
              <span class="titleslight--text font-weight-bold">Usuario</span>
              <span class="titleslight--text font-weight-bold ml-1">*</span>
              <v-text-field
                v-model="user"
                :rules="userValidacion"
                outlined
                dense
                required>
              </v-text-field>
              <span class="titleslight--text font-weight-bold">Correo</span>
              <span class="titleslight--text font-weight-bold ml-1">*</span>
              <v-text-field 
                v-model="email"
                :rules="emailValidacion"
                outlined
                dense
                required>
              </v-text-field>
              <small class="d-flex justify-end"><span class="titleslight--text font-weight-bold">* Campo Obligatorio</span></small>
            </v-form>
          </v-card-text>
          <!-- <v-divider></v-divider> -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            class="font-weight-bold"
              color="btncolor"  
              @click="restorePass()"
              dark>
              Restablecer
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import axiosServices from "@/services/axiosServices.js"
export default {
  name:'restorepassword',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: '',
      email: '',
      Activo: false,
      dialog: false,
      bValidate: false,
      emailValidacion: [
        v => !!v || 'Correo es requerido',
        v => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/.test(v) || 'Dirección de correo no valida',
      ],
      userValidacion: [
        v => !!v || 'Usuario es requerido'
      ],
    }
  },
  methods: {
    crear() {
      this.dialog = true;
      this.$emit("input", this.dialog);
    },
    validateInputs() {
      this.bValidate = false;
      if (this.user !== "" && this.email !== "" &&
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/.test(this.email)) {
        this.bValidate = true;
      }
      return this.bValidate;
    },
    restorePass() {
      if (this.validateInputs()) {
        let oBody = {
          "sLogin": this.user,
          "sEmail": this.email
        };
        axiosServices.postConfiguration('restore_password', oBody)
        .then(aResponse => {
          if (aResponse.nStatusCode == 200) {
            this.$store.dispatch('SetMensaje', "Le hemos enviado un enlace de recuperación a su dirección de correo electrónico.");
            this.$store.dispatch('ShowNotificacion', true);
            this.CloseDialog();
          }
        });
      } else {
        this.$store.dispatch('SetMensaje', "Uno de los campos se encuentra vacio.");
        this.$store.dispatch('ShowNotificacion', true);
      }
    },
    CloseDialog() {
      this.user = '';
      this.email = '';
      this.dialog = false;
      this.$emit("input", this.dialog);
    },
  },
}
</script>
